import { isNil } from 'lodash';
import React from 'react';

export const BodyCell = ({
  cell: { label, cellComponent, align, padding, paddingLeft, paddingRight, color, width, style, colSpan },
  stickyHeaderObserverAnchor,
  mobile,
}) => {
  return (
    <td
      colSpan={colSpan}
      className={mobile ? 'mobile-table__body-cell' : 'custom-table__body-cell'}
      align={align || 'left'}
      style={{ padding, paddingLeft, paddingRight, color, width, ...style }}
    >
      {stickyHeaderObserverAnchor ? <div className="sticky-header-observer-anchor" /> : null}
      {cellComponent ? cellComponent : !isNil(label) ? label : ''}
    </td>
  );
};
